export const OfficeConsultationSettingsState = {
	url: '/settings-consultation',
	title: 'Office Consultation Settings',
	template: '<consultation-settings></consultation-settings>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeSettingsConsultationPageMod" */
			'@Containers/office-consultation-settings/office-consultation-settings.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
